import ExternalResourceLink from '../core/ExternalResourceLink';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { default as React } from 'react';
import CancelButton from './CancelButton';
import { globalStyles as styles } from './style/gstheme';
import { Typography } from '@material-ui/core';

class ExternalLinkDialog extends React.Component {

    state = {
        open: true
    };

    exitLinkDialog = () => {
        this.setState({ open: false });
        this.props.onClose();
    };

    render() {

        const { classes, id, noAccess } = this.props;
        const { open } = this.state;

        return (
            <React.Fragment>
                <Dialog
                    data-test="external-link-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={open} onClose={this.exitInfoDisalog} aria-labelledby="external-link-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="external-link-dialog-title">Resource Detail</DialogTitle>
                    <DialogContent>
                        {noAccess ?
                            <Typography data-test="no-permissions" variant="body2" paragraph>You do not have permission to view this resource within this project.</Typography>
                            :
                            <Typography variant="body2" paragraph>This resource does not exist within this project.</Typography>
                        }
                        <ExternalResourceLink
                            dataTest={"link"}
                            id={id}
                            isReadOnly={true} />
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitLinkDialog} />
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

ExternalLinkDialog.propTypes = {
    id: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    noAccess: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(ExternalLinkDialog);